<p-table #dt styleClass="p-datatable-gridlines p-datatable-striped p-datatable-sm" [value]="catalogues" sortField="position"
[autoLayout]="true">

    <ng-template pTemplate="header">
        <tr>
            <th>Nom catalogue</th>
            <th>Fichier</th>
            <th>position</th>
            <th>
                <p-button icon="pi pi-plus" (click)="addRow()" styleClass="p-button-help"> </p-button>

            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row let-i="rowIndex">
        <tr *ngIf="!row.edit">
            <td>
                {{row.name_catalogue}}
            </td>
            <td>
                <a *ngIf="row.url" [href]="row.url" target="_blank" class="p-button-link">
                    <i class="pi pi-file-pdf mr-1"></i>Voir le catalogue
                </a>
            </td>
            <td>{{row.position}}</td>
            <td class="flex gap-2">
                <p-button icon="pi pi-pencil" (click)="row.edit = true"  styleClass="p-button-info">  </p-button>
                <p-button icon="pi pi-trash" (click)="delete(row)" styleClass="p-button-danger p-button"></p-button>

                </td>
        </tr>
        <tr *ngIf="row.edit">
            <td>
                <input pInputText type="text" [(ngModel)]="row.name_catalogue" />

            </td>
            <td>
                <div class="flex flex-column gap-2">
                    <p-fileUpload #fu mode="basic" accept=".pdf,.jpg,.jpeg,.png,.webp" chooseLabel="Choisir un fichier" chooseIcon="pi pi-upload" (onSelect)="onFileSelect($event, row); fu.clear()" [auto]="true"></p-fileUpload>
                    <small *ngIf="row._fileName" class="text-green-500"><i class="pi pi-check mr-1"></i>{{row._fileName}}</small>
                    <small *ngIf="row.url && !row._fileName" class="text-500">Fichier actuel : {{row.url | slice:-30}}</small>
                </div>
            </td>
            <td>
                <p-inputNumber [size]="2" [(ngModel)]="row.position" mode="decimal" [min]="0" [max]="99" [showButtons]="true" [buttonLayout]="'horizontal'"></p-inputNumber>
            </td>
            <td class="flex gap-2">
                <p-button icon="pi pi-save" (click)="save(row)" [loading]="uploading[i]"> </p-button>
            </td>
        </tr>
    </ng-template>
</p-table>

<div class="mt-4 p-3 surface-card border-round shadow-1">
    <h4 class="mt-0 mb-3">Bilan RSE</h4>
    <div class="flex align-items-center gap-3">
        <p-fileUpload #fuRSE mode="basic" accept=".pdf" chooseLabel="Uploader le Bilan RSE" chooseIcon="pi pi-upload" (onSelect)="onRSESelect($event); fuRSE.clear()" [auto]="true"></p-fileUpload>
        <a [href]="rseUrl" target="_blank" class="p-button-link">
            <i class="pi pi-file-pdf mr-1"></i>Voir le Bilan RSE actuel
        </a>
    </div>
</div>